import _slicedToArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/layouts/Grid/grid';
import { css } from '@patternfly/react-styles';
import { DeviceSizes } from '../../styles/sizes';
export var Grid = function Grid(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      hasGutter = _a.hasGutter,
      _a$span = _a.span,
      span = _a$span === void 0 ? null : _a$span,
      props = __rest(_a, ["children", "className", "hasGutter", "span"]);

  var classes = [styles.grid, span && styles.modifiers["all_".concat(span, "Col")]];
  Object.entries(DeviceSizes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propKey = _ref2[0],
        gridSpanModifier = _ref2[1];

    var key = propKey;
    var propValue = props[key];

    if (propValue) {
      classes.push(styles.modifiers["all_".concat(propValue, "ColOn").concat(gridSpanModifier)]);
    }

    delete props[key];
  });
  return React.createElement("div", Object.assign({
    className: css.apply(void 0, classes.concat([hasGutter && styles.modifiers.gutter, className]))
  }, props), children);
};